import React from 'react';
import { Box, Avatar, Button, Typography, useTheme } from '@mui/material'

import { useDispatch } from 'react-redux';
import { setSelectedPromptItem } from '../reducers/uiReducer';


const SelectedTileHeader = ({
    icon,
    title,
    setShowSelectedItem,
    selectedItem,
    setSelectedItem
}) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const isButtonDisabled = !selectedItem;

    const handleButtonClick = () => {
        dispatch(setSelectedPromptItem(null));
        setSelectedItem(null);
        setShowSelectedItem(false);
    };

    return (
        <Box display="flex" alignItems="center">
            <Avatar sx={{ mr: 1 }}>{icon || null}</Avatar>
            <Button
                onClick={handleButtonClick}
                disabled={isButtonDisabled}
                color="primary"
                sx={{
                    fontSize: '16px',
                    textTransform: 'none',
                    color: theme => theme.palette.primary.main,
                    '&.Mui-disabled': {
                        color: theme =>
                            theme.palette.mode === 'dark'
                                ? theme.palette.grey[600]
                                : theme.palette.grey[800],
                    },
                }}
            >
                {title || 'Missing title'}
            </Button>
            {(selectedItem) && (
                <>
                    <Typography>&nbsp;/&nbsp;</Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: '16px',
                            fontWeight: 500,
                            color: theme.palette.text.secondary,
                        }}
                    >
                        {selectedItem || 'Missing title'}
                    </Typography>
                </>
            )}
        </Box>
    );
};

export default SelectedTileHeader;
